import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { IService } from "shared/models/service.model";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class ServiceData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private tracking: TrackingProvider,
  ) { }

  public createOrUpdate(clientId: string, service: IService) {
    if (service.id === "") {
      this.action = "create";
      service.id = this.afDb.createPushId();
      service.created_at = new Date().getTime();
    } else {
      this.action = "update";
      service.update_at = new Date().getTime();
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${clientId}/Services/${service.id}`)
        .update(service)
        .then(() => {
          return this.historyData.set(
            `Service content`,
            "services",
            this.action,
            service,
          );
        })
        .then(() => {
          this.tracking.trackEntity(_TRACKING_ENTITIES.SERVICE, service.id, clientId, service);
          resolve(service);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public createOrUpdateGroups(client: string, group: any) {
    if (group.id === "") {
      this.action = "create";
      group.id = this.afDb.createPushId();
      group.created_at = new Date().getTime();
    } else {
      this.action = "update";
      group.update_at = new Date().getTime();
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/ServiceGroups/${group.id}`)
        .update(group)
        .then(() => resolve(group))
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getByClientId(client: string): Observable<IService[]> {
    return this.afDb.list<IService>(`Clients/${client}/Services`).valueChanges();
  }

  public getActiveByClientId(clientId: string): Observable<IService[]> {
    return this.afDb.list<IService>(
      `Clients/${clientId}/Services`,
      (ref) => ref.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getGroupsActiveByClientId(clientId: string): Observable<any[]> {
    return this.afDb.list<any>(
      `Clients/${clientId}/ServiceGroups`,
      (ref) => ref.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getGroupById(clientId: string, groupId: string): Observable<any> {
    return this.afDb
      .object<any>(`Clients/${clientId}/ServiceGroups/${groupId}`)
      .valueChanges();
  }

  public getById(clientId: string, serviceId: string): Observable<IService> {
    return this.afDb
      .object<IService>(`Clients/${clientId}/Services/${serviceId}`)
      .valueChanges();
  }

  public saveServiceRules(client: string, rules: any) {
    return this.afDb.object(`Clients/${client}/ServiceRules`).set(rules);
  }

  public getServicesRules(client: string) {
    return this.afDb.list(`Clients/${client}/ServiceRules`).valueChanges();
  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/services.ts